import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var MyTopicsComponent = /** @class */ (function () {
    function MyTopicsComponent(dashboardService, errorHandlerService, router) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.mytopics = [];
        this.moremytopics = [];
        this.myjointopics = [];
        this.moremyjointopics = [];
        this.loadmoreText1 = "Load More";
        this.loadmoreText = "Load More";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.myTopics = null;
        this.myJoinTopics = null;
        this.myTopicsAll = null;
        this.myTopics = this.dashboardService.myTopics();
        this.myJoinTopics = this.dashboardService.myJoinTopics();
        this.myTopicsAll = this.myTopics.merge(this.myJoinTopics);
    }
    MyTopicsComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Start Spinner
        this.showSpinner = true;
        var myTopicsCompleted = false;
        var myJoinTopicsCompleted = false;
        var s1 = this.myTopicsAll.subscribe(function (data) {
            if (data.topicInitializationType === 'MYTOPICS') {
                _this.mytopics = data;
                myTopicsCompleted = true;
                console.log(_this.mytopics);
            }
            else {
                _this.myjointopics = data;
                myJoinTopicsCompleted = true;
                console.log(_this.myjointopics);
            }
            // Stop Spinner
            if (myTopicsCompleted == true && myJoinTopicsCompleted == true) {
                _this.showSpinner = false;
            }
        }, function (error) {
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        /*this.dashboardService.myTopics().subscribe(
          data => {this.mytopics = data;console.log(this.mytopics);},
          error => {console.log(error);this.handleError(error);}
        );
        this.dashboardService.myJoinTopics().subscribe(
          data => {this.myjointopics = data;console.log(this.myjointopics);},
          error => {console.log(error);this.handleError(error);}
        );*/
    };
    MyTopicsComponent.prototype.lodeMoremyTopic = function () {
        var _this = this;
        this.showSpinner = true;
        var s2 = this.dashboardService.loadmoremyTopics().subscribe(function (data) {
            if (data.length == 0) {
                _this.loadmoreText1 = "No More Data";
            }
            else {
                data.forEach(function (element) {
                    _this.mytopics.push(element);
                });
                _this.loadmoreText1 = "Load More";
            }
            _this.showSpinner = false;
        }, function (error) { console.log(error); _this.handleError(error); });
        this.subscriptions.push(s2);
    };
    MyTopicsComponent.prototype.lodeMorejoinTopic = function () {
        var _this = this;
        this.showSpinner = true;
        var s3 = this.dashboardService.loadmorejoinTopics().subscribe(function (data) {
            if (data.length == 0) {
                _this.loadmoreText = "No More Data";
            }
            else {
                data.forEach(function (element) {
                    _this.myjointopics.push(element);
                });
                _this.loadmoreText = "Load More";
            }
            _this.showSpinner = false;
        }, function (error) { console.log(error); _this.handleError(error); });
        this.subscriptions.push(s3);
    };
    MyTopicsComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    MyTopicsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return MyTopicsComponent;
}());
export { MyTopicsComponent };
//# sourceMappingURL=mytopics.component.js.map